export const variantClasses = {
  headingOne:
    'text-[36px] font-bold sm:text-[48px] sm:font-bold leading-none leading-tight break-words hyphens-auto',
  headingTwo:
    'text-[28px] font-bold sm:text-[36px] sm:font-bold leading-10 leading-tight break-words hyphens-auto',
  headingThree:
    'text-[22px] font-medium sm:text-[24px] sm:font-medium leading-10 leading-tight break-words hyphens-auto',
  headingFour:
    'text-[18px] font-medium sm:text-[20px] sm:font-medium leading-5 leading-tight break-words hyphens-auto',
  largeTextM: 'text-[16px] font-medium sm:text-[18px] sm:font-medium leading-5',
  largeTextR: 'text-[16px] font-normal sm:text-[18px] sm:font-normal leading-5',
  baseTextM: 'text-[14px] font-medium sm:text-[16px] sm:font-medium leading-5',
  baseTextR: 'text-[14px] font-normal sm:text-[16px] sm:font-normal leading-5',
  smallTextM: 'text-[12px] font-medium sm:text-[14px] sm:font-medium leading-5',
  smallTextR: 'text-[12px] font-normal sm:text-[14px] sm:font-normal leading-5',
  captions:
    'text-[12px] font-medium uppercase sm:text-[14px] sm:font-medium uppercase',
};

export const spacingClasses = {
  none: 'my-0',
  small: 'my-2',
  medium: 'my-4',
  large: 'my-6',
};
